import { gql } from '@apollo/client';

export const FETCH_QUERY_BUILDER_GROUPS_GQL = gql`
  query listQueryBuilderGroups(
    $tenantID: ID!
    $searchTerm: String
    $limitOptions: Int
  ) {
    listQueryBuilderGroups(
      request: {
        tenantID: $tenantID
        searchTerm: $searchTerm
        limitOptions: $limitOptions
      }
    ) {
      groups {
        id
        displayName
        type
        hasMore
        options {
          field {
            field
            displayName
            iconURL
            valueType
            objectType
            isMultiValue
            detail {
              metadata {
                source
                references {
                  key
                  displayName
                  source
                  iconURL
                }
              }
              reference {
                creatorName
                referenceID
                referenceType
                creatorID
              }
            }
          }
          value {
            value
            displayName
            iconURL
          }
          isCompleteMatch
        }
      }
    }
  }
`;
